import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import ajax from '../../shared/ajax';
import AppError from '../../shared/AppError';
import { INVALID_TOKEN_CODE } from '../../shared/constants';
import actionsAndConstants from '../../shared/actionsAndConstants';
import dashboardMassUploadEpics from './massUpload';

const {
  app: { actions: appActions },
  dashboard: {
    actions: dashboardActions,
    constants: dashboardConstants
  }
} = actionsAndConstants;

const loadStats = action$ =>
  action$.ofType(dashboardConstants.loadStats)
    .switchMap(({ payload: { ajaxOptions = {} } = {} }) =>
      ajax(ajaxOptions)
        .map(({ detalle }) => dashboardActions.loadStatsSucceeded(detalle[0]))
        .catch((error) => {
          if (error instanceof AppError && error.code === INVALID_TOKEN_CODE) {
            return Observable.of(appActions.invalidToken({
              alert: { message: error.description }
            }));
          }
          return Observable.of(dashboardActions.loadStatsFailed({
            alert: { message: error.description || error.message }
          }));
        }));

export default combineEpics(
  loadStats,
  dashboardMassUploadEpics
);



// WEBPACK FOOTER //
// ./src/epics/dashboard/index.js